import React, { useState } from "react";
import axios from "axios";
import config from "../config.js";
// import { Grid, Paper, TextField, Button, makeStyles } from '@material-ui/core';
import { Grid, Paper, TextField, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import swal from "sweetalert";
import Cookies from "universal-cookie";
import mixpanel from "mixpanel-browser";
import Navbar from "./Navbar";

// Define custom styles using makeStyles
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#424242",
    marginTop: theme.spacing(4),
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#6a6a6a",
      },
      "&:hover fieldset": {
        borderColor: "#9c9c9c",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4a6da7",
      },
    },
    "& .MuiInputLabel-outlined": {
      color: "#e0e0e0",
    },
    "& .MuiOutlinedInput-input": {
      color: "#ffffff",
    },
    marginBottom: theme.spacing(2),
  },
  button: {
    backgroundColor: "#3f51b5",
    color: "#ffffff",
    padding: "12px",
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#303f9f",
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

const Inviteform = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const cookies = new Cookies();

  let userToken = "";
  let userID = "";
  try {
    userToken = cookies.get("userToken");
    userID = cookies.get("userID");
  } catch (error) {}

  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Clear any existing errors before submitting
    setError("");

    mixpanel.track("Send Invite Button Clicked", {
      userID: cookies.get("userID"),
    });

    // Send email to server
    axios
      .post(config.BACKEND_URL + "/invite-user", { email }, { headers })
      .then((res) => {
        // Handle success response
        if (res.status === 203) {
          setError(res.data.message);
          return swal("Duplicate Email", res.data.message, "error");
        }
        // Clear error state on success
        setError("");
        swal(
          "Invitation Sent successfully",
          "Please ask user to register before 24hr",
          "success"
        );
        setEmail(""); // Clear the input after successful submission
      })
      .catch((err) => {
        // Handle error response
        console.log(err);
        const errorMessage =
          err.response?.data?.message ||
          "Error sending invite. Please try again.";
        setError(errorMessage);
      });
  };

  const handleEmailChange = (event) => {
    const newEmail = event.target.value;
    setEmail(newEmail);

    // Clear error when user starts typing a new email
    if (error) {
      setError("");
    }
  };

  return (
    <div className="Invites">
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <Navbar />
      <main className={classes.container}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Paper className={classes.paper}>
              <form onSubmit={handleSubmit} className={classes.form}>
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  required
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  error={error.length > 0}
                  helperText={error}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  className={classes.button}
                >
                  SEND INVITE
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default Inviteform;
